<template>
  <div id="register-step3" class="register-step">
    <b-loading :active="showPageLoader"></b-loading>
    <div id="main-part" v-if="getRegisterConfiguration !== null">
      <div class="register-header register-header-margin">
        <div>
          <a @click="prevStep">
            <span class="icon"> <i class="mdi mdi-arrow-left"></i> </span>
          </a>
        </div>
        <h2>3/3 FILIACIÓN</h2>

        <div>
          <a @click="closeRegister">
            <span class="icon"> <i class="mdi mdi-exit-to-app"></i> </span>
          </a>
        </div>
      </div>

      <div class="register-content">
        <p style="margin-bottom: 3em;" v-html="texts.register.step3.text1"></p>

        <div class="register-forms-container">
          <!-- <b-field
            :message="citymsg"
            :type="citytype"
            v-if="getFieldInfo('provincia')"
          > -->
          <b-field
            :message="citymsg"
            :type="citytype"       
            v-if="this.cities"     
          >
            <b-icon
              class="onlyline-icon"
              pack="mdi"
              icon="map-marker"
              size="is-small"
            >
            </b-icon>
            <b-autocomplete
              expanded
              class="onlyline"
              rounded
              v-model="cityname"
              :data="filteredDataArray"
              placeholder="Localidad"
              :open-on-focus="openOnFocus"
              icon="magnify"
              field="name"
              :keep-first="keepfirst"
              @select="citySelected"
              ref="cityname"
            >
              <template slot="empty">No hay resultados</template>
            </b-autocomplete>
          </b-field>
          <div v-if="isLoading">
            Cargando datos...
            <div style="text-align:center">
              <Loader> </Loader>
            </div>
          </div>
          <template v-if="dataLoaded">
            <template>
              <b-field
                :message="jobcentermsg"
                :type="jobcentertype"
                v-if="getFieldInfo('centro_trabajo') && this.$store.state.register.country.id === 'ES'"
              >
                <b-icon
                  class="onlyline-icon"
                  pack="mdi"
                  icon="hospital-building"
                  size="is-small"
                >
                </b-icon>
                <b-autocomplete
                  expanded
                  class="onlyline"
                  rounded
                  v-model="jobcentername"
                  :data="filteredDataArrayJobcenters"
                  placeholder="Centro de Trabajo"
                  :open-on-focus="openOnFocus"
                  icon="magnify"
                  field="name"
                  :keep-first="keepfirst"
                  @select="jobcenterSelected"
                  ref="jobcentername"
                >
                  <template slot="header">
                    <a @click="showCustomCenter">
                      <span class="has-text-weight-light is-italic">
                        Busca tu centro o añádelo <br />
                        si no está en la lista</span
                      >
                    </a>
                  </template>
                  <template slot="empty"
                    >No hemos encontrado tu centro de trabajo.
                    Escribelo</template
                  >
                  <template slot="footer">
                    <a @click="showCustomCenter">
                      <span> Añadir centro </span>
                    </a>
                  </template>
                </b-autocomplete>
              </b-field>

              <b-field v-if="this.$store.state.register.country.id !== 'ES'">
                <b-icon
                  class="onlyline-icon"
                  pack="mdi"
                  icon="account"
                  size="is-small"
                >
                </b-icon>
                <b-input
                  type="text"
                  class="onlyline"
                  placeholder="Centro de trabajo"
                  expanded
                  v-model="selected_jobcenter_other"
                  required
                  ref="jobcenter_otherField"                  
                >
            </b-input>
          </b-field>

              <b-field
                :message="specialitymsg"
                :type="specialitytype"
                v-if="getFieldInfo('especialidad') || this.$store.state.register.country.id !== 'ES'"
              >
                <b-icon
                  class="onlyline-icon"
                  pack="mdi"
                  icon="medical-bag"
                  size="is-small"
                >
                </b-icon>
                <b-autocomplete
                  expanded
                  class="onlyline"
                  rounded
                  v-model="specialityname"
                  :data="filteredDataArraySpecialities"
                  placeholder="Especialidad"
                  :open-on-focus="openOnFocus"
                  icon="magnify"
                  field="name"
                  :keep-first="keepfirst"
                  @select="specialitySelected"
                  ref="specialityname"
                >
                  <template slot="empty">Sin resultados.</template>
                </b-autocomplete>
              </b-field>
            </template>
          </template>
        </div>
      </div>
      <div class="register-button-container">
        <a
          class="register-button button is-fullwidth is-primary"
          @click="nextStep"
          v-if="dataLoaded"
        >
          Terminar
        </a>
      </div>
    </div>
    <!-- main part -->
    <div id="belowbutton">
      <p class="interface-small-text has-text-grey-light"></p>
    </div>
  </div>
  <!-- register-step-->
</template>
<script>
import Loader from '../UI/Loader'
import { RegisterStepMixin } from '../mixins/RegisterStepMixin'
import { ToolsMixin } from '../mixins/ToolsMixin'
import { cities } from '@/assets/cities.js'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
  name: 'RegisterStep3',
  components: {
    Loader
  },
  mixins: [RegisterStepMixin, ToolsMixin],
  data: () => ({
    cities: cities,
    selectedcity: null,
    cityname: '',
    selectedJobcenter: null,
    selected_jobcenter_other: null,
    jobcentername: '',
    selectedSpeciality: null,
    specialityname: '',
    /*centrosdetrabajo: [
      { id: '1', name: 'centro 1' },
      { id: '2', name: 'centro 2' },
      { id: '3', name: 'centro 3' }
    ],
    especialidades: [
      { id: '1', name: 'especialidad 1' },
      { id: '2', name: 'especialidad 2' },
      { id: '3', name: 'especialidad 3' }
    ],*/
    openOnFocus: true,
    isLoading: false,
    keepfirst: true,
    citymsg: '',
    citytype: '',
    specialitymsg: '',
    specialitytype: '',
    jobcentermsg: '',
    jobcentertype: '',
    showPageLoader: false
  }),
  methods: {
    showCustomCenter() {
      this.$buefy.dialog.prompt({
        message: `Nombre de tu centro de trabajo`,
        inputAttrs: {
          placeholder: 'Hospital, centro de salud ...',
          maxlength: 20,
          value: this.name
        },
        confirmText: 'Añadir',
        onConfirm: value => {
          this.jobcenter_other = { id: -1, name: value, uuid: -1 }
          this.$refs.jobcentername.setSelected(this.jobcenter_other)
        }
      })
    },
    nextStep() {
      if (this.isFormValid()) {

        let doctor_jobcenter_other = ''
        let doctor_jobcenter = ''
        if (this.selected_jobcenter_other) {
          this.selectedJobcenter = { id: -1, name: this.selected_jobcenter_other, uuid: -1 }
          this.jobcentername = this.selected_jobcenter_other
        }
        if (this.selectedJobcenter.id == -1)
          doctor_jobcenter_other = this.jobcentername
        else doctor_jobcenter = this.selectedJobcenter.id
        this.showPageLoader = true
        this.$store.commit('register/setStep3', {
          doctor_jobcenter: doctor_jobcenter,
          doctor_jobcenter_other: doctor_jobcenter_other,
          administrative_area: this._.get(this.selectedcity, 'id', ''),
          doctor_specialty_main: this._.get(this.selectedSpeciality, 'tid', '')
        })
        console.log(
          'Starting register/register0, createAccount0, api/user/register'
        )
        this.$store
          .dispatch('register/register0', {
            mail: this.$store.state.register.mail,
            pass: this.$store.state.register.pass,
            terms: this.$store.state.register.globalTermsID
          })
          .then(() => {
            console.log('register/register0 ok Starting login0')
            //after register0 is successfuly done
            this.$store
              .dispatch('register/login0', {
                mail: this.$store.state.register.mail,
                pass: this.$store.state.register.pass
              })
              .then(() => {
                this.subscribeToSlave()
              })
              .catch(error => {
                //esto realmente es el caso esperado tras hacer login
                console.log(
                  'register/login0 responde usuario necesita suscribirse'
                )
                this.subscribeToSlave()
                if (error.response) {
                  console.log(error.response.data)
                  console.log(error.response.status)
                  console.log(error.response.headers)
                }
              })
          })
          .catch(error => {
            this.showPageLoader = false
            //Falla el register0
            console.log('register/register0 response error')
            console.log(error.response.data)
          })
      } else {
        this.$matomo.trackEvent(this.generateMatomoEventCategory(), 'Step 5', 'Not_Valid_Form')
        console.log('formulario no valido')
        Toast.open({
          duration: 8000,
          message:
            'No es posible enviar, ¿Has rellenado todos los datos del formulario de forma correcta?',
          type: 'is-danger'
        })
      }
      //this.$store.commit('register/nextStep')
    },
    subscribeToSlave() {
      this.$store.commit(
        'register/setServerCredentials',
        this.$store.state.register.firstLoginInfo.data.server_credentials
      )
      console.log(' subscribeToSlave antes de lanzar register/subscribe')
      this.$store
        .dispatch('register/subscribe', this.$store.state.isApp)
        .then(() => {
          console.log(' subscribe resuelve bien. Falta hacer login definitivo')
          this.$store
            .dispatch('auth/login', {
              email: this.$store.state.register.mail,
              password: this.$store.state.register.pass
            })
            .then(() => {

            console.log(' login funciona y hace la suscripcion con el código de invitacion')

        this.$store
          .dispatch('register/validatePremiumCodeAuth', this.$store.state.register.premiumCode)
          .finally(() => {
                     console.log(' pasa al siguiente componente')
              this.$store.commit('register/nextStep')
              this.$matomo.trackEvent(this.generateMatomoEventCategory(), 'Step 5', 'Next')
     })
            })
        })
    },
    citySelected(option) {
      this.selectedcity = option
      if (option === null) this.cityname = ''
      else this.cityname = option.name
      this.validateCityname()
    },
    jobcenterSelected(option) {
      this.selectedJobcenter = option
      if (option === null) this.jobcentername = ''
      else this.jobcentername = option.name
      this.validateJobcenter()
    },
    specialitySelected(option) {
      this.selectedSpeciality = option
      if (option === null) this.specialityname = ''
      else this.specialityname = option.name
      this.validateSpeciality()
    },
    isFormValid() {
      if (this.$store.state.register.country.id === 'ES') {
        return (
        ((!this.getFieldInfo('provincia') || this.validateCityname()) &&
          (this.getFieldInfo('especialidad') || this.validateSpeciality()) &&
          this.getFieldInfo('centro_trabajo')) ||
        this.validateJobcenter()
      )
      } else if (this.$store.state.register.country.id === 'PT' || this.$store.state.register.country.id === 'PY' || this.$store.state.register.country.id === 'UY') {
        return (
        (this.validateSpeciality() && this.selected_jobcenter_other)                 
        )
      }
      else{
        return (
        (this.validateCityname()) && this.validateSpeciality() && this.selected_jobcenter_other                  
        )
      }
      
    },
    validateCityname() {
      var cityname2 = this.cityname.toLowerCase()
      var vv = this.cities.filter(element => {
        return (
          element.name
            .toString()
            .toLowerCase()
            .indexOf(cityname2) >= 0
        )
      })
      if (vv.length > 0) {
        this.citymsg = ''
        this.citytype = 'is-success'
        return true
      } else {
        this.citymsg = 'Parece que no es un nombre de provincia apropiado'
        this.citytype = 'is-danger'
        return false
      }
    },
    validateJobcenter() {
      if (this.jobcentername.length > 3) {
        this.jobcentermsg = ''
        this.jobcentertype = 'is-success'
        return true
      } else {
        this.jobcentermsg =
          'Selecciona un centro de trabajo. Si no aparece el tuyo escríbelo. '
        this.jobcentertype = 'is-danger'
        return false
      }
    },
    validateSpeciality() {
      var specialityname2 = this.specialityname.toLowerCase()
      var vv = this.getSpecialitiesArray.filter(element => {
        return (
          element.name
            .toString()
            .toLowerCase()
            .indexOf(specialityname2) >= 0
        )
      })
      if (vv.length > 0) {
        this.specialitymsg = ''
        this.specialitytype = 'is-success'
        return true
      } else {
        this.specialitymsg = 'Selecciona una especialidad de la lista. '
        this.specialitytype = 'is-danger'
        return false
      }
    }
  },
  computed: {
    dataLoaded() {
      if (this.$store.state.register.country.id === 'ES') {
        return (
        this.$store.state.register.jobcenters.length > 0 &&
        this.$store.state.register.specialities.length > 0
        )  
      }else{
        if (this.$store.state.register.administrative_areas) {
          return this.$store.state.register.specialities.length > 0 && this.$store.state.register.administrative_areas.length > 0  
        }else{
          return this.$store.state.register.specialities.length > 0
        }
        
      }
      
    },
    getSpecialitiesArray() {
      return this.$store.state.register.specialities
    },
    getJobcentersArray() {
      return this.$store.state.register.jobcenters
    },
    filteredDataArray() {
      return this.cities.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.cityname.toLowerCase()) >= 0
        )
      })
    },
    filteredDataArraySpecialities() {
      return this.getSpecialitiesArray.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.specialityname.toLowerCase()) >= 0
        )
      })
    },
    filteredDataArrayJobcenters() {
      return this.getJobcentersArray.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.jobcentername.toLowerCase()) >= 0
        )
      })
    }
  },
  watch: {
    selectedcity: function() {
      console.log(this.selectedcity)      
      if (this.selectedcity !== null && 'id' in this.selectedcity && this.$store.state.register.country.id === 'ES') {
        this.selectedJobcenter = null
        this.jobcentername = ''
        this.isLoading = true
        // eslint-disable-next-line
        this.$store
          .dispatch('register/getJobcenters', {
            administrative_area: this.selectedcity.id
          })
          .then(() => {
            this.isLoading = false
          })
      }
    }
  },
  created() {
    this.isLoading = true
    this.$store
      .dispatch('register/getAdministrativeAreas', {
        country: this.$store.state.register.country.id
      })
      .then(() => {
        this.isLoading = false
        this.cities = this.$store.state.register.administrative_areas
      })
    this.$store.dispatch('register/getSpecialities', {
        country: this.$store.state.register.country.id
      })
  }
}
</script>
<style lang="less" scoped>
//@import (reference) '../../assets/styles/main.less';
/*#register-card {
  background-color: @primaryColor;
  display: flex;
  justify-content: center;
  flex-direction: column;
} */

.register-button-container {
  margin-top: 2rem;
}

.apellido {
  margin-left: 15px;
}
#colegiado-number .onlyline {
  margin-right: 1em;
}
.xx,
.yy {
  width: 2.7em;
}
.zzzzz {
  width: 5em;
}
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* For Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
/* Webkit browsers like Safari and Chrome */
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.input-row input[type='number']::-webkit-inner-spin-button,
.input-row input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
</style>
